(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5558],{

/***/ 80153:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[partner]",
      function () {
        return __webpack_require__(23955);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qW": function() { return /* reexport */ black_membership; },
  "YZ": function() { return /* reexport */ black_plus_membership; },
  "Xs": function() { return /* reexport */ dynasty_dining_membership; },
  "b0": function() { return /* reexport */ dynasty_membership; },
  "s7": function() { return /* reexport */ gold_membership; },
  "CY": function() { return /* reexport */ partners_footer; },
  "Vo": function() { return /* reexport */ partners_header; },
  "Sm": function() { return /* reexport */ partners_header_2; },
  "YN": function() { return /* reexport */ travel_journal_hero; }
});

// UNUSED EXPORTS: silverMembershipPNG

;// CONCATENATED MODULE: ./assets/black_membership.png
/* harmony default export */ var black_membership = ({"src":"/_next/static/media/black_membership.89d63625.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEUZGRlCQkEpKCU2NjbzRtKyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIklEQVR4nB3IwQ0AMBDCMMPtv3NF87IiKUpyNMPWP4k1HB4DKgAhWfvXYwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/black_plus_membership.png
/* harmony default export */ var black_plus_membership = ({"src":"/_next/static/media/black_plus_membership.0bde2d9f.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAD1BMVEVEQ0IYGBgrKSYgHx82NjYEDsYOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJElEQVR4nC3JwQ0AMAyDQLCz/8yR0v7QAVQbgdFQgHy5+WLUBQRRAC3yPmMjAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/gold_membership.png
/* harmony default export */ var gold_membership = ({"src":"/_next/static/media/gold_membership.87a9fcf4.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEWkk3W4pYSvnoG9sZxpvOI1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVR4nB3JwQ0AMBACIPT237mpPxIkUJLS+5iG5VA8AusAH7czvuEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/silver_membership.png
/* harmony default export */ var silver_membership = ({"src":"/_next/static/media/silver_membership.99059e53.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAElBMVEXu7u7j4+Po6Ojd3d3Nzc2pqal7IW5rAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJUlEQVR4nB3KwQ0AMAyDQHDc/Veukt9JAESnApi+WcTpAc2lvfwFEgAz4xAiVQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/dynasty_membership.png
/* harmony default export */ var dynasty_membership = ({"src":"/_next/static/media/dynasty_membership.58020613.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEX29fP+/v74+Pjs5toRryfmAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAACFJREFUeJwtiUEOADAMQLD//3lp2hMBUiUq5cWZw51M1D4EngAzoU00MgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/dynasty_dining_membership.png
/* harmony default export */ var dynasty_dining_membership = ({"src":"/_next/static/media/dynasty_dining_membership.d56ef584.png","height":600,"width":880,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAADFBMVEXx8fD+/v749/fs5trk6oFvAAAAAXRSTlP+GuMHfQAAAAlwSFlzAAALEwAACxMBAJqcGAAAACJJREFUeJwtybENACAMwLAk/P8zKmWzZEiVqLTzYQJPi8kLBOUANjWE7tYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./assets/partners_header.png
/* harmony default export */ var partners_header = ({"src":"/_next/static/media/partners_header.754372d5.png","height":1078,"width":2560,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAMFBMVEWAhXZta12CobljcnRkXDZ1dnaMlpasyNWNp8J1b2hWUD2btcptkLecs7x+ho15ZUvbCLqIAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAI0lEQVR4nGPgZWfn5mBjYGZgYGNi4mFmYWHgYuVjZGTl5AcAB9YAldC+7G4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./assets/partners_footer.png
/* harmony default export */ var partners_footer = ({"src":"/_next/static/media/partners_footer.5891e7bd.png","height":1020,"width":2560,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAIVBMVEWpo5+TlZjBwb+hoZ+Ad3SVioOfko2KiIaImKhXXm+tuszhlBAnAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAIklEQVR4nAXBgQEAIAjDsG6AQ/8/2IRxBE+Mi06Fu6s+5gME1QBgb0+aagAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./assets/partners-header-2.webp
/* harmony default export */ var partners_header_2 = ({"src":"/_next/static/media/partners-header-2.5037f2fa.webp","height":1078,"width":3300,"blurDataURL":"data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAQAgCdASoIAAMAAkA4JbACdLoAAwkaEd8AAP4JCVWu1nvgKeI907zXh1cUbnOP/B2Iec5Otnndp0AA","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./assets/travel-journal-hero.webp
/* harmony default export */ var travel_journal_hero = ({"src":"/_next/static/media/travel-journal-hero.851e428d.webp","height":563,"width":1920,"blurDataURL":"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACwAQCdASoIAAIAAkA4JZwCdAEO/dXAAP6mz7c6epO1LQQoT94gygxSSdbqBoAA","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./assets/index.ts













/***/ }),

/***/ 11443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PartnerLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./blocks/DialoguePresenter/DialoguePresenter.tsx
var DialoguePresenter = __webpack_require__(38114);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./components/NavigationItem/NavigationItem.tsx
var NavigationItem = __webpack_require__(10493);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsIcon.tsx
var LittleEmperorsIcon = __webpack_require__(21965);
// EXTERNAL MODULE: ./customHooks/useDialogue/useDialogue.ts
var useDialogue = __webpack_require__(82113);
// EXTERNAL MODULE: ./components/icons/BurgerMenuIcon.tsx
var BurgerMenuIcon = __webpack_require__(61063);
// EXTERNAL MODULE: ./components/icons/LittleEmperorsTextIcon.tsx
var LittleEmperorsTextIcon = __webpack_require__(15096);
// EXTERNAL MODULE: ./customHooks/useJoinUs/useJoinUs.ts
var useJoinUs = __webpack_require__(1698);
;// CONCATENATED MODULE: ./blocks/Header/PartnerHeader.tsx















var PartnerHeader = function() {
    var about_text = (0,useLocalised/* default */.Z)(translationKeys.about);
    var membership_text = (0,useLocalised/* default */.Z)(translationKeys.membership);
    var our_hotels_text = (0,useLocalised/* default */.Z)(translationKeys.our_hotels);
    var openDialogue = (0,react.useContext)(useDialogue/* DialogueContext */.$).openDialogue;
    var handleBurgerMenuClick = (0,react.useCallback)(function() {
        openDialogue(constants/* MOBILE_PARTNER_MENU_DIALOGUE */.Ii);
    }, [
        openDialogue
    ]);
    var ref = (0,react.useContext)(useJoinUs/* JoinUsContext */.L), state = ref.joinUsState, setState = ref.setState;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "header-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "header-component__container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-left",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: about_text,
                            path: constants/* navigationPaths.HOMEPAGE */.aY.HOMEPAGE,
                            className: "header-navigation-item"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            className: "navigation-item",
                            href: constants/* navigationPaths.MEMBERSHIP */.aY.MEMBERSHIP,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "header-navigation-item",
                                "area-label": membership_text,
                                onClick: function() {
                                    setState(function(state) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                            memberShipCategory: constants/* membershipCategoryOptions.LEISURE */.N9.LEISURE
                                        });
                                    });
                                },
                                children: membership_text
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItem/* default */.Z, {
                            title: our_hotels_text,
                            path: constants/* navigationPaths.OUR_HOTELS */.aY.OUR_HOTELS,
                            className: "header-navigation-item"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "burger-icon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: handleBurgerMenuClick,
                        title: "mobile-menu",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BurgerMenuIcon/* default */.Z, {})
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "header-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: constants/* navigationPaths.HOMEPAGE */.aY.HOMEPAGE,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: constants/* navigationPaths.HOMEPAGE */.aY.HOMEPAGE,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "area-label": "homepage",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LittleEmperorsTextIcon/* default */.Z, {
                                    color: constants/* colorConstants.brandColor */.Q_.brandColor
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "header-rigth"
                })
            ]
        })
    });
};
/* harmony default export */ var Header_PartnerHeader = (PartnerHeader);

// EXTERNAL MODULE: ./blocks/Footer/Footer.tsx + 3 modules
var Footer = __webpack_require__(53114);
// EXTERNAL MODULE: ./blocks/search-bar/context.tsx
var context = __webpack_require__(62643);
;// CONCATENATED MODULE: ./blocks/Layouts/PartnerLayout.tsx



//Components


//Providers

var GlobalLayout = function(param) {
    var children = param.children, memberships = param.memberships, currencies = param.currencies, countryCodes = param.countryCodes, metaData = param.metaData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaData.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "Little Emperors"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaData.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaData.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaData.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_PartnerHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "main-content-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* SearchBarProvider */.t, {
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialoguePresenter/* default */.Z, {
                memberships: memberships,
                currencies: currencies,
                countryCodes: countryCodes
            })
        ]
    });
};
/* harmony default export */ var PartnerLayout = (GlobalLayout);


/***/ }),

/***/ 5505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var ArrowLeft = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "10",
        height: "16",
        viewBox: "0 0 10 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1 8.07107L8.07107 15.1421L8.77817 14.435L2.41421 8.07107L8.77817 1.70711L8.07107 1L1 8.07107Z",
            fill: "#191919"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowLeft);


/***/ }),

/***/ 10997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var ArrowRight = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "10",
        height: "16",
        viewBox: "0 0 10 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.77817 8.07107L1.70711 1L1 1.70711L7.36396 8.07107L1 14.435L1.70711 15.1421L8.77817 8.07107Z",
            fill: "#191919"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowRight);


/***/ }),

/***/ 2466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ BaseText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13394);
/* harmony import */ var components_shared_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63057);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4093);
/* harmony import */ var _BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5__);








var BaseText = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "p" : _as, children = _param.children, _color = _param.color, color = _color === void 0 ? "black" : _color, weight = _param.weight, fontStyle = _param.fontStyle, letterSpacing = _param.letterSpacing, fontSize = _param.fontSize, align = _param.align, style = _param.style, isLink = _param.isLink, className = _param.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "as",
        "children",
        "color",
        "weight",
        "fontStyle",
        "letterSpacing",
        "fontSize",
        "align",
        "style",
        "isLink",
        "className"
    ]);
    var colorStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getColorFromString */ .T)(color);
    var fontWeightStyle = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .getFontWeightFromString */ .J)(weight);
    var marginStyle = (0,components_shared_utils__WEBPACK_IMPORTED_MODULE_2__/* .getMarginFromProps */ .X)(rest);
    var joinedClassName = classnames__WEBPACK_IMPORTED_MODULE_3___default()((_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().baseText), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_BaseText_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link), isLink), className);
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: joinedClassName,
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            fontWeight: fontWeightStyle,
            fontStyle: fontStyle,
            color: colorStyle,
            textAlign: align,
            letterSpacing: letterSpacing,
            fontSize: fontSize
        }, marginStyle, style)
    }, rest), children);
};


/***/ }),

/***/ 7117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);




var Body = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (Body);


/***/ }),

/***/ 36443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85392);
/* harmony import */ var _Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Heading = function(_param) {
    var _as = _param.as, as = _as === void 0 ? "h1" : _as, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "as"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        as: as,
        className: (_Heading_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[as]
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 82096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _BaseText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2466);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26926);
/* harmony import */ var _Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Small_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var Small = function(_param) {
    var _xs = _param.xs, xs = _xs === void 0 ? false : _xs, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "xs"
    ]);
    var joinedClassNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Small_module_scss__WEBPACK_IMPORTED_MODULE_4___default().xs), xs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseText__WEBPACK_IMPORTED_MODULE_1__/* .BaseText */ .k, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        as: "small",
        className: joinedClassNames
    }, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Small);


/***/ }),

/***/ 22538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X6": function() { return /* reexport safe */ _Heading__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "uT": function() { return /* reexport safe */ _Body__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "x4": function() { return /* reexport safe */ _Small__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var _Body__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7117);
/* harmony import */ var _Small__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82096);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36443);





/***/ }),

/***/ 13394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ getColorFromString; },
  "J": function() { return /* binding */ getFontWeightFromString; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/shared/constants.ts
var constants = __webpack_require__(55774);
;// CONCATENATED MODULE: ./components/text/constants.ts
var weights = {
    regular: 400,
    medium: 500,
    demiBold: 600
};

;// CONCATENATED MODULE: ./components/text/utils.ts



var getColorFromString = function(colorString) {
    var ref = (0,_sliced_to_array/* default */.Z)(colorString.split("-"), 2), colorName = ref[0], shade = ref[1];
    var color = shade ? constants/* colors */.O[colorName][shade] : constants/* colors */.O[colorString];
    return color ? color : constants/* colors.black */.O.black;
};
var getFontWeightFromString = function(weightString) {
    if (!weightString) {
        return null;
    }
    var weight = weights[weightString];
    return weight ? weight : weights.regular;
};


/***/ }),

/***/ 23955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var blocks_Layouts_PartnerLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11443);
/* harmony import */ var styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(40926);
/* harmony import */ var styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var assets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61681);
/* harmony import */ var components_text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22538);
/* harmony import */ var components_container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49985);
/* harmony import */ var components_Button_BaseButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26200);
/* harmony import */ var components_HotelsCarousel_HotelsCarousel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95102);
/* harmony import */ var customHooks_useDialogue_useDialogue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82113);
/* harmony import */ var data_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84749);
/* harmony import */ var customHooks_useJoinUs_useJoinUs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1698);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_12__);
















var PartnerPage = function(props) {
    var openDialogue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(customHooks_useDialogue_useDialogue__WEBPACK_IMPORTED_MODULE_9__/* .DialogueContext */ .$).openDialogue;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(customHooks_useJoinUs_useJoinUs__WEBPACK_IMPORTED_MODULE_11__/* .JoinUsContext */ .L), state = ref.joinUsState, setState = ref.setState;
    var partner = props.partner, globalLayoutProps = props.globalLayoutProps;
    var _tier;
    var membershipTier = (_tier = partner.tier) !== null && _tier !== void 0 ? _tier : "Travel";
    //list of partners that should have a transparent logo
    // this is a quick fix for making all mastercard partner pages have a transparent logo
    var transparentLogoPartners = [
        "mastercard",
        "horizons",
        "tottenhamhotspurs",
        "monument", 
    ];
    var shouldLogoBeTransparent = transparentLogoPartners.includes(partner.slug);
    var masterCardFirstLine = "Little Emperors is a members-only hotel club, guaranteeing the lowest rates and the most benefits at the best luxury hotels around the world. As a ".concat(partner.name, " cardholder, we are delighted to extend a complimentary ").concat(membershipTier, " membership to you.");
    var about = {
        title: "About Little Emperors",
        contents: [
            "".concat(partner.landing_page_introduction_message || ""),
            "With over 5,000 hotel partners, a membership with Little Emperors is the essential travel companion. So whether it’s the Royal Monceau in Paris, the new Six Senses in Rome, the Baccarat in New York or the Four Seasons in Dubai, you can sleep easy knowing you have the best rates and benefits with us.", 
        ]
    };
    var handleSignUpClick = function() {
        setState((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, state), {
            membershipId: membershipTier.toLocaleLowerCase(),
            promoCode: {
                required: partner.require_promo_code,
                partnerCode: "",
                coupon: partner.coupon
            },
            requireCard: partner.require_card,
            formType: "LEPartner"
        }));
        openDialogue(data_constants__WEBPACK_IMPORTED_MODULE_10__/* .JOIN_US_DIALOG_STEP_2 */ .pn);
    };
    var partnerLogoClass = classnames__WEBPACK_IMPORTED_MODULE_12___default()((styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().partnerLogo), (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().transparent));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(blocks_Layouts_PartnerLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, globalLayoutProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().heroHeaderContainer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().headerImageContainer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            priority: true,
                            src: assets__WEBPACK_IMPORTED_MODULE_4__/* .partnersHeaderTransparentWEBP */ .Sm,
                            layout: "fill",
                            objectPosition: "center",
                            objectFit: "cover",
                            alt: "Little Emperors Partners"
                        })
                    }),
                    partner.logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: partnerLogoClass,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            priority: true,
                            src: partner.logo,
                            layout: "fill",
                            objectPosition: "center",
                            objectFit: "contain",
                            alt: "Little Emperors Partners"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().heroHeaderContent),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_text__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
                                fontSize: 16,
                                weight: "demiBold",
                                color: "white",
                                children: "Enjoy a complimentary"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_text__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X6, {
                                fontSize: 19,
                                weight: "demiBold",
                                mt: 5,
                                as: "h5",
                                color: "white",
                                letterSpacing: "0.285em",
                                children: [
                                    membershipTier.toUpperCase(),
                                    " MEMBERSHIP"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().about),
                        children: about.contents.map(function(content, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_text__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X6, {
                                mt: i === 1 ? 20 : 0,
                                as: "h5",
                                color: "grey-dark",
                                children: content
                            }, i.toString());
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().benefits),
                        children: benefits.contents.map(function(benefit) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_text__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X6, {
                                        as: "h4",
                                        color: "gold-dark",
                                        children: benefit.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_text__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
                                        color: "grey-dark",
                                        children: benefit.text
                                    })
                                ]
                            }, benefit.title);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().heroFooterContainer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().headerImageContainer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: assets__WEBPACK_IMPORTED_MODULE_4__/* .partnersFooterPNG */ .CY,
                            layout: "fill",
                            objectPosition: "center",
                            objectFit: "cover",
                            alt: "Little Emperors Partners"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().topGradient)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().heroFooterContent),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_text__WEBPACK_IMPORTED_MODULE_5__/* .Heading */ .X6, {
                                        as: "h4",
                                        children: "Claim your membership"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_text__WEBPACK_IMPORTED_MODULE_5__/* .Body */ .uT, {
                                        color: "grey-dark",
                                        children: "Join the club now to unlock a world of incredible hotels at the best rates and with the most benefits."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button_BaseButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                size: "full",
                                onClick: handleSignUpClick,
                                className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().button),
                                children: "Sign up"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (styles_pages_partner_index_module_css__WEBPACK_IMPORTED_MODULE_15___default().carousel),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HotelsCarousel_HotelsCarousel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    isPartner: true
                })
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PartnerPage);
var benefits = {
    title: "There are so many reasons to be part of the club - here are just a few:",
    contents: [
        {
            title: "The lowest prices, guaranteed",
            text: "The best prices at more than 5,000 handpicked, luxury hotels across the globe. Enjoy your stay, safe in the knowledge that your booking matches the cancellation, payment and loyalty-point collection as when booking with hotels directly."
        },
        {
            title: "Real benefits",
            text: "We only present our members with actual benefits. Breakfasts, hotel credits, confirmed upgrades and add-on experiences are just some of the complimentary extras our members are eligible for."
        },
        {
            title: "A personalised experience",
            text: "Our portfolio of hotels on our app and website are personalised with relevant offers and recommendations, just for you. Our members enjoy our state-of-the-art technology (and booking in just a few clicks)."
        },
        {
            title: "Real people",
            text: "Our team of London-based travel advisors is ready to guide you via phone, email and WhatsApp, sharing insider knowledge to ensure an unforgettable trip."
        }, 
    ]
};


/***/ }),

/***/ 40926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroHeaderContainer":"partner_heroHeaderContainer__3ZmSS","heroFooterContainer":"partner_heroFooterContainer__4vArC","imageHeaderContainer":"partner_imageHeaderContainer__BZRYL","transparent":"partner_transparent__C_gUH","whiteBg":"partner_whiteBg__5K5ye","partnerLogo":"partner_partnerLogo__beX5X","heroHeaderContent":"partner_heroHeaderContent__V65Fs","about":"partner_about__NwGmf","content":"partner_content__204ff","benefits":"partner_benefits__s6Szs","topGradient":"partner_topGradient__1dZ9o","heroFooterContent":"partner_heroFooterContent__xLblR","button":"partner_button__eCj_M","carousel":"partner_carousel__Cyt75"};

/***/ }),

/***/ 4093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseText":"BaseText_baseText__UdRof","link":"BaseText_link__iIUwY"};

/***/ }),

/***/ 85392:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"h1":"Heading_h1__JrX4F","h2":"Heading_h2__meWYJ","h3":"Heading_h3__7RMCn","h4":"Heading_h4__IrnJ5","h5":"Heading_h5__pT9p1"};

/***/ }),

/***/ 26926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"small":"Small_small__B42wk","xs":"Small_xs__SqaGj"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,5675,1608,4520,6343,9774,2888,179], function() { return __webpack_exec__(80153); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);